import React from "react";
import { Provider } from "react-redux";
import { setupStore } from "store";
import { Router } from "router";
import { GlobalStyle } from "assets/styles";
import { theme } from "theme";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const App = () => {
  const store = setupStore();

  return (
    <Provider store={store}>
      <GlobalStyle />
      <ToastContainer />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router />
      </ThemeProvider>
    </Provider>
  );
};
